import React, { useState, useEffect } from 'react';
import { object, func, bool, string } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { ALERT_TYPE, ShowToastMessage, sequenceActionNext } from '@laramie/ui';
import { TableCustom, MessageModal } from '../../common';
import { CloneObject } from '../../../utils/helpers';
import { useLista } from '../../hooks/useLista';
import DocumentoModal from '../DocumentoModal';
import DataTaggerModalRedux from '../DataTaggerModalRedux';
import { isNull } from '../../../utils/validator';
import { TIPS } from '../../../consts/tips';

const DocumentosGrid = (props) => {

  //hooks
  const [state, setState] = useState({
      idTipoPersona: 0,
      idPersona: 0,
      disabled: false,
      showMessage: false,
      showForm: false,
      modeFormEdit: false,
      rowForm: null,
      dataTagger: {
        showModal: false,
        idEntidad: null
      },      
      list: []
  });

  const [documentos, setDocumentos] = useState([]);

  const dispatch = useDispatch();
  const sequenceValue = useSelector( (state) => state.sequence.value );

  const mount = () => {
    setState(prevState => {
      const list = props.data.list.filter(x => x.state !== 'r');
      return {...prevState,
        idTipoPersona: props.data.idTipoPersona,
        idPersona: props.data.idPersona,
        list: list };
    });
  }
  useEffect(mount, [props.data]);

  const [, getRowLista] = useLista({
    listas: ['TipoDocumento'],
    onLoaded: (listas, isSuccess, error) => {
      if (isSuccess) {
        setState(prevState => ({...prevState}));
      }
      else {
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
      }
    },
    memo: {
      key: 'TipoDocumento',
      timeout: 0
    }
  });

  const cellA = (data) =>    <div className='action'>
                                {!props.disabled && (
                                  <div onClick={ (event) => handleClickDocumentoAdd() } className="link">
                                      <span className="material-symbols-outlined" title="Nuevo">add</span>
                                  </div>
                                )}
                              </div>
  const cellVMR = (data) =>  <div className='action'>
                                  <div onClick={ (event) => handleClickDocumentoView(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="Ver">search</span>
                                  </div>
                                  {!props.disabled && (
                                  <div onClick={ (event) => handleClickDocumentoModify(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="Modificar">stylus</span>
                                  </div>
                                  )}
                                  {!props.disabled && !data.row.original.principal && (
                                  <div onClick={ (event) => handleClickDocumentoRemove(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="Eliminar">delete</span>
                                  </div>
                                  )}
                                  <div onClick={ (event) => handleClickDocumentosDataTagger(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="Información adicional">info</span>
                                  </div>                                  
                              </div>

  const getDescTipoDocumento = (id) => {
    const row = getRowLista('TipoDocumento', id);
    return (row) ? row.nombre : '';
  }

  const tableColumns = [
    { Header: 'Principal', Cell: (props) => (props.value) ? 'Si' : 'No', accessor: 'principal', width: '20%' },
    { Header: 'Tipo de documento', Cell: (props) => getDescTipoDocumento(props.value), accessor: 'idTipoDocumento', width: '30%' },
    { Header: 'Documento', accessor: 'numeroDocumento', width: '40%' },
    { Header: cellA, Cell: cellVMR, id:'abm', accessor: 'id', width: '10%', disableGlobalFilter: true, disableSortBy: true }
  ];


  //handles
  const handleClickDocumentoAdd = () => {
    const idTemporal = (-1)*sequenceValue; //los registros temporales tienen id negativa
    setState(prevState => {
      const rowForm = {
        id: idTemporal,
        idTipoPersona: state.idTipoPersona,
        idPersona: state.idPersona,
        idTipoDocumento: 0,
        numeroDocumento: '',
        principal: (state.list.length === 0),
        state: 'a'
      };
      return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm};
    });
    setDocumentos(state.list);
    dispatch( sequenceActionNext() );
  }
  const handleClickDocumentoView = (id) => {
    setState(prevState => {
      const rowForm = state.list.find(x => x.id === id);
      return {...prevState, showForm: true, modeFormEdit: false, rowForm: rowForm};
    });
  }
  const handleClickDocumentoModify = (id) => {
    setState(prevState => {
      const rowForm = state.list.find(x => x.id === id);
      return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm};
    });
    setDocumentos(state.list.filter(x => x.id !== id));
  }
  const handleClickDocumentoRemove = (id) => {
    setState(prevState => {
      const rowForm = state.list.find(x => x.id === id);
      return {...prevState, showMessage: true, rowForm: rowForm};
    });
  }

  const handleClickDocumentosDataTagger = (id) => {
    setState(prevState => {
      return {...prevState, dataTagger: {showModal: true, idEntidad: id}};
    });
  }  

  //funciones
  function RemoveDocumento(row) {
    row.state = 'r';
    props.onChange('Documento', row);
  }

  function UpdateDocumento(row) {
    const original = state.list.find(x => x.id === row.id);
    row.state = isNull(original) ? 'a' : 'm';
    
    //si es nuevo o cambio el atributo principal hay que hacer validaciones
    if (row.state === "a" ||  row.principal !== original.principal) {
      //listado de otros principales (deberia ser uno o ninguno)
      let listOthers = state.list.filter(x => x.id !== row.id && x.principal && x.state !== 'r');
      if (listOthers.length === 0) {
        row.principal = true; //forzadamente es principal
      }
      else if (row.principal) {
        listOthers.forEach((item, index) => {
          item.principal = false; //ningun otro puede ser principal
          item.state = 'm';
        });
      }
    }

    props.onChange('Documento', row);
  }

  return (
  <>

    {state.dataTagger.showModal &&
      <DataTaggerModalRedux
          title="Información adicional de documento"
          processKey={props.processKey}
          entidad="Documento"
          idEntidad={state.dataTagger.idEntidad}
          disabled={props.disabled}
          tipName={TIPS.NAME.MODALS.INFORMACION_ADICIONAL_DOCUMENTO_MODAL}
          onDismiss={() => {
            setState(prevState => {
              return {...prevState, dataTagger: {showModal: false, idEntidad: null}};
            });
          }}
      />
    }

    {state.showMessage && 
        <MessageModal
            title={"Confirmación"}
            message={"¿Está seguro de borrar el registro?"}
            onDismiss={() => {
              setState(prevState => {
                  return {...prevState, showMessage: false, rowForm: null};
              });
            }}
            onConfirm={() => {
              const row = CloneObject(state.rowForm);
              setState(prevState => {
                  return {...prevState, showMessage: false, rowForm: null};
              });
              RemoveDocumento(row);
            }}
        />
    }

    {state.showForm && 
        <DocumentoModal
            processKey={props.processKey}
            disabled={!state.modeFormEdit}
            data={{
              entity: state.rowForm,
              listDocumentos: documentos
            }}
            onDismiss={() => {
              setState(prevState => {
                  return {...prevState, showForm: false, rowForm: null};
              });
            }}
            onConfirm={(row) => {
              setState(prevState => {
                  return {...prevState, showForm: false, rowForm: null};
              });
              UpdateDocumento(row);
            }}
        />
    }

    <TableCustom
        showFilterGlobal={false}
        className={'TableCustomBase'}
        columns={tableColumns}
        data={state.list}
    />

  </>
  );
}

DocumentosGrid.propTypes = {
  processKey: string.isRequired,
  disabled: bool,
  data: object.isRequired,
  onChange: func.isRequired
};

DocumentosGrid.defaultProps = {
  disabled: false
};

export default DocumentosGrid;